<mat-card
    class="daxa-card recent-orders-card  border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-0 outline-0 rounded-pill "
                       placeholder="Chercher un utilisateur..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-pill border-0" (click)="openModal(content)">
                <span class="px-2">Nouveau</span>
            </button>
        </mat-card-subtitle>

    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>

                    <!-- select Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell
                            *matHeaderCellDef>
                            <mat-checkbox (change)="handleSelectAll()" [checked]="isAllSamplesSelected"/>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="isAllSamplesSelected" (change)="handleSelection(element)"/>
                        </td>
                    </ng-container>

                    <!--  <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                        <td mat-cell *matCellDef="let element"> {{ element.id }}</td>
                    </ng-container>

                   sampleType Column -->
                    <ng-container matColumnDef="Username">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Username</th>
                        <td mat-cell *matCellDef="let element"> {{ element.username }}</td>
                    </ng-container>

                    <!-- collectedBy Column -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Nom</th>
                        <td mat-cell *matCellDef="let element"> {{ element.name }}</td>
                    </ng-container>
                    <ng-container matColumnDef="prenom">
                        <th mat-header-cell *matHeaderCellDef> Prénom </th>
                        <td mat-cell *matCellDef="let element"> {{ element.prenom }}</td>
                    </ng-container>
                    <!-- collectionDate Column -->
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef> Email</th>
                        <td mat-cell *matCellDef="let element"> {{ element.email}}</td>
                    </ng-container>
                    <ng-container matColumnDef="departmentName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Département </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.departmentNames }}
                        </td>
                    </ng-container>


                    <!--<ng-container matColumnDef="preleveur">
                        <th mat-header-cell *matHeaderCellDef> Préleveur </th>
                        <td mat-cell *matCellDef="let element"> 
                          {{ element.preleveur ? '✅' : '❌' }}
                        </td>
                      </ng-container>-->
                      
                    <!-- updateDate Column -->
                    <ng-container matColumnDef="hiringDate">
                        <th mat-header-cell *matHeaderCellDef> Date d'embauche
                        </th>
                        <td mat-cell *matCellDef="let element"> {{ element.hiringDate | date: 'short' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef> Address </th>
                        <td mat-cell *matCellDef="let element"> {{ element.address }}</td>
                    </ng-container>
                    <ng-container matColumnDef="site">
                        <th mat-header-cell *matHeaderCellDef> Site </th>
                        <td mat-cell *matCellDef="let element"> {{ element.site }}</td>
                    </ng-container>

                    <!-- dateReception Column -->
                    <ng-container matColumnDef="phone">
                        <th mat-header-cell *matHeaderCellDef> Téléphone</th>
                        <td mat-cell *matCellDef="let element"> {{ element.phone }}</td>
                    </ng-container>

                    <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef> Rôles </th>
                    <td mat-cell *matCellDef="let element">
                        <span *ngFor="let role of element.roles; let i = index">
                        {{ roleLabels[role.replace('ROLE_', '').toLowerCase()] || role.replace('ROLE_', '') }}
                        <span *ngIf="i < element.roles.length - 1">, </span>
                        </span>
                    </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Action</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">

                                <button type="button" mat-button matTooltip="Visualiser les détails"
                                        matTooltipPosition="above" (click)="openViewModel(element)"
                                >
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="editUser(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="7" *ngIf="!loadingTable">Aucun résultat trouvé pour utilisateurs</td>
                    </tr>
                </table>
                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

        </div>

    </mat-card-content>
</mat-card>
<!-- modal template for add -->
<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Créer un Utilisateur
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
           <form [formGroup]="form" (ngSubmit)="saveUser()">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Username</mat-label>
                            <input matInput formControlName="username" required>  <mat-error *ngIf="form.get('username')?.hasError('required')">Username is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="name" required>  </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Prénom</mat-label>
                            <input matInput formControlName="prenom" required>  <mat-error *ngIf="form.get('prenom')?.hasError('required')">Prénom est obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="email" placeholder="Ex. email@gmail.com" required>  </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                        <mat-label>Départements</mat-label>
                        <mat-select id="departments" formControlName="departmentIds" multiple>
                            <mat-option *ngFor="let dep of departments" [value]="dep.id">
                                {{ dep.name }}
                            </mat-option>
                        </mat-select>            
                        </mat-form-field>
                    </div>
                      
                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Password</mat-label>
                            <input matInput formControlName="password" required>  </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Date d'embauche</mat-label>
                            <input matInput readonly [matDatepicker]="picker" formControlName="hiringDate" required>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker class="custom-datepicker"></mat-datepicker>
                            <mat-error *ngIf="form.get('hiringDate')?.hasError('required')">Date d'embauche requise</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4">
                    <mat-form-field>
                        <mat-label>Rôles</mat-label>
                        <mat-select formControlName="role" multiple required>
                        <mat-option *ngFor="let role of roleList" [value]="role">
                            {{ roleLabels[role] }}
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Téléphone</mat-label>
                            <input matInput formControlName="phone" required>  </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Address</mat-label>
                            <input matInput formControlName="address" required>  </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>MultiSite</mat-label>
                            <input matInput formControlName="site" required>  </mat-form-field>
                    </div>
            
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                       <div class="col-sm-12 col-md-12 col-lg-6">
  <label for="signature">Signature</label>
  <input type="file" id="signature" (change)="onFileSelected($event)" accept=".png,.jpg,.jpeg" />
  <mat-hint>Choisir une image PNG ou JPG</mat-hint>

</div>

                      </div>
                      
                      
                    <div class="col-sm-12 text-right mt-3">
                        <button type="submit" class="btn btn-outline-success">Enregister</button>
                    </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<!-- modal template for infos -->
<ng-template #viewModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <h5 class="fw-bold mx-3">
            Détails Utilisateur
        </h5>
        <div class="row m-3">
            <div class="col-sm-6 col-lg-4 border-top border-0 p-3 ">
                <div class="fw-bold">Username :</div>
                <p>{{ form.get('username')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Nom :</div>
                <p>{{ form.get('name')?.value }}</p>
            </div>
           <div class="col-sm-6 col-lg-4 border-top border-0 p-3 ">
                <div class="fw-bold">Prénom :</div>
                <p>{{ form.get('prenom')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Date d'embauche :</div>
                <p>{{ form.get('hiringDate')?.value  | date : 'short'}}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Téléphone :</div>
                <p>{{ form.get('phone')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div>
                    <div class="fw-bold">Address :</div>
                    <p>{{ form.get('address')?.value }}</p>
                </div>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div>
                    <div class="fw-bold">MultiSite :</div>
                    <p>{{ form.get('site')?.value }}</p>
                </div>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Email :</div>
                <p>{{ form.get('email')?.value }}</p>
            </div>
           <!-- <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Préleveur :</div>
                <p>{{ form.get('preleveur')?.value ? '✅ Oui' : '❌ Non' }}</p>
              </div>
              
            -->
            <div class="col-sm-6 col-lg-4 border-top p-3">
            <div class="fw-bold">Rôles :</div>
                <p *ngIf="form.get('role')?.value?.length > 0; else noRole">
                <span>
                    {{ getRoleLabelsString(form.get('role')?.value) }}
                </span>
                </p>
                <ng-template #noRole>
                <p class="text-muted">Aucun rôle attribué</p>
                </ng-template>


            </div>     
        </div>
    </mat-card>
</ng-template>

<!-- Modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Modifier Utilisateur
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="saveUpdatedUser()">
                <div class="row">
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="name">
                            <mat-error *ngIf="form.get('name')?.hasError('required')">Nom requis</mat-error>
                        </mat-form-field>
                    </div>
                   <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Prénom</mat-label>
                            <input matInput formControlName="prenom">
                            <mat-error *ngIf="form.get('prenom')?.hasError('required')">Prénom requis</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Email</mat-label>
                            <input matInput formControlName="email">
                            <mat-error *ngIf="form.get('email')?.hasError('required')">Email requis</mat-error>
                        </mat-form-field>
                    </div>  
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                        <mat-label>Département</mat-label>
                        <mat-select formControlName="departmentIds" multiple>
                            <mat-option *ngFor="let dept of departments" [value]="dept.id">
                                {{ dept.name }}
                            </mat-option>
                        </mat-select> 
                        <mat-error *ngIf="form.get('departmentIds')?.hasError('required')">
                            Département requis
                        </mat-error>
                        </mat-form-field>
                    </div>                 
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Date d'embauche</mat-label>
                            <input matInput readonly [matDatepicker]="picker" formControlName="hiringDate">
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker class="custom-datepicker"></mat-datepicker>
                            <mat-error *ngIf="form.get('hiringDate')?.hasError('required')">
                                Date d'embauche requise
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Adresse</mat-label>
                            <input matInput formControlName="address" placeholder="Ex. 06, Rue X">
                            <mat-error *ngIf="form.get('address')?.hasError('required')">Adresse requise</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>MultiSite</mat-label>
                            <input matInput formControlName="site" placeholder="Ex. MultiSite">
                            <mat-error *ngIf="form.get('site')?.hasError('required')">Site requise</mat-error>
                        </mat-form-field>
                    </div>


                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Téléphone</mat-label>
                            <input matInput formControlName="phone" placeholder="Ex. +123 12345678">
                            <mat-error *ngIf="form.get('phone')?.hasError('required')">Téléphone requis</mat-error>
                        </mat-form-field>
                    </div>

                <div class="col-sm-6 col-lg-4">
                <mat-form-field class="mb-25">
                    <mat-label>Rôles</mat-label>
                    <mat-select formControlName="role" multiple> 
                    <mat-option *ngFor="let role of roleList" [value]="role">
                        {{ roleLabels[role] || role }}
                    </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('role')?.hasError('required')">Rôle requis</mat-error>
                </mat-form-field>
                </div>

                    <!--<div class="col-sm-6 col-lg-4">
                        <mat-checkbox formControlName="preleveur">
                          Est préleveur ?
                        </mat-checkbox>
                    </div>  -->
                    <!-- Champ pour entrer l'URL de l'image -->
                    <div class="col-sm-6 col-lg-4">
                    <label>Signature</label>
                    <input type="file"
                            accept=".png,.jpg,.jpeg"
                            (change)="onSignatureSelected($event)">
                    </div>    
    
</div>
                <div class="col-sm-12 text-right mt-3">
                    <button type="submit" class="btn btn-outline-success">Enregistrer</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>
